import { StoryData } from '@cinch-nx/data-storyblok'
import { CarCollectionsStory } from '../storyblok'

export const carCollectionsFallbackStory: StoryData<CarCollectionsStory> = {
  name: 'car-collections',
  created_at: '2026-04-22T14:09:08.823Z',
  published_at: '2026-05-07T14:45:24.662Z',
  id: 168_662_420_822_562,
  uuid: 'bcf30de3-01e3-44af-bf0e-9e5b1bdfa407',
  content: {
    SEO: [],
    _uid: '3a4ca5f6-3f5b-4ad2-b986-7503c2e0cb83',
    body: [
      {
        _uid: 'd264fcdc-94fd-4d3a-be66-d3d4e23dbb5f',
        title: 'Search for a collection location',
        subtitle: '',
        component: 'FindASite',
        searchButtonText: 'Search',
        showMoreButtonText: 'Show more',
        siteCardButtonText: 'Find out more',
        showCinchStoresFreeOnCard: true,
        alwaysShowCinchStoresFirst: true,
        showCinchStoreFirstIfInClosestSites: false,
      },
      {
        _uid: 'f19e94cc-1b80-41df-a870-c756e42d6fe2',
        component: 'LandingTextInlineImageSection',
        textInlineImages: [
          {
            _uid: '5652a609-849f-4ee4-93f8-f50d69d92512',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'About collections',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'When you buy a car, you’ll be able to choose what suits you from all the available collection options for that car.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can take your pick from convenient locations across the country. Time slots are available from Monday to Saturday, 8am to 6pm.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'One of our team will meet you there to give you the keys and answer any questions you have about the car.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'And if you’re part-exchanging, you can drop off your old car with us when you pick up your new one.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Find out about the options you have to collect your car from cinch:',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            image: {
              id: 168_665_801_750_435,
              alt: 'A customer receiving a car from a staff member.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/768x983/a3169c2800/customer-receives-car.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'A customer receiving a car from a staff member.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
          },
          {
            _uid: 'dd67be7a-22e5-48ea-9ca6-3c3e539708f5',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Stores',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'If your car’s in one of ',
                      type: 'text',
                    },
                    {
                      text: 'our cinch Stores',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://help.cinch.co.uk/hc/en-gb/articles/23778618706461-Where-s-my-nearest-cinch-Store',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                    {
                      text: ', you can collect it from there for free.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'If your car’s not in your local cinch Store, we can move it to your nearest one for you to collect. This costs £99.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Collection from the cinch Store your car’s already in: ',
                              type: 'text',
                            },
                            {
                              text: 'free',
                              type: 'text',
                              marks: [
                                {
                                  type: 'bold',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Move to your nearest cinch Store for collection: ',
                              type: 'text',
                            },
                            {
                              text: '£99',
                              type: 'text',
                              marks: [
                                {
                                  type: 'bold',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 168_665_801_930_660,
              alt: 'Picture of a cinch store with several cars visible',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/2685x3024/6f47497566/cinch-store-northampton-collections-page.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Picture of a cinch store with several cars visible',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
          },
          {
            _uid: '8ec03882-144f-41e9-8db6-28710ad9c06e',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch Click & Collect locations',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can collect any car located in one of our cinch Stores from our ',
                      type: 'text',
                    },
                    {
                      text: 'click and collect locations.',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://help.cinch.co.uk/hc/en-gb/articles/26672354057373-Where-s-my-nearest-cinch-Click-Collect-branch',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'underline',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Cost of collection at a cinch Click & Collect location: ',
                              type: 'text',
                            },
                            {
                              text: '£99',
                              type: 'text',
                              marks: [
                                {
                                  type: 'bold',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 168_665_802_020_773,
              alt: 'Picture of a staff member handing over the keys of a newly collected car to a customer.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/834x1067/67db04a916/person-handing-over-keys.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Picture of a staff member handing over the keys of a newly collected car to a customer.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
          },
          {
            _uid: '85f99d82-6ea9-48ad-98ed-004cba75a94f',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Marshall collection',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can collect some of our cars from selected Marshall stores nationwide for free, where available.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'cinch and Marshall are both part of the Constellation Automotive Group, so some of our cars are kept at Marshall locations.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Collection from selected Marshall stores (if your car’s already there): ',
                              type: 'text',
                            },
                            {
                              text: 'free',
                              type: 'text',
                              marks: [
                                {
                                  type: 'bold',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 168_665_802_069_929,
              alt: 'Picture of a building with the Marshall sign on the front.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/1360x2048/7f14ec57c3/marshall-location.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Picture of a building with the Marshall sign on the front.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
          },
          {
            _uid: 'de88373a-0550-4005-bc5a-84d688c6e581',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'webuyanycar branches',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'You can choose to pick up your new motor from 100+ webuyanycar branches across the UK.',
                      type: 'text',
                    },
                  ],
                },
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Use the map above to find the one closest to you.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            image: {
              id: 168_665_802_041_254,
              alt: 'Picture of a staff member inspecting a car with a tablet in their hand.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/768x983/039e76da17/person-inspecting-car.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Picture of a staff member inspecting a car with a tablet in their hand.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'right',
          },
          {
            _uid: '601b6795-c52f-47a5-9d76-90e00b33174f',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'heading',
                  attrs: {
                    level: 2,
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'How collections work',
                      type: 'text',
                      marks: [
                        {
                          type: 'bold',
                        },
                      ],
                    },
                  ],
                },
                {
                  type: 'bullet_list',
                  content: [
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Choose a collection location and time slot during checkout',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'We’ll email you with all the important details (e.g. address, date and time)',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Get regular updates, including when your car’s on the way to its collection point',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Bring your driving licence or passport (and V5C log book if you’re part exchanging)',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    {
                      type: 'list_item',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'A member of our team will answer any questions you have about the car before you drive away',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            image: {
              id: 168_665_802_061_735,
              alt: 'Staff member explaining features of a car during a handover to customer.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/768x983/f222f848e2/handover-to-customer.png',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Staff member explaining features of a car during a handover to customer.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'LandingTextInlineImage',
            imagePosition: 'left',
          },
        ],
      },
      {
        _uid: 'da9ff1ae-0a20-447e-9192-60d5c2ed3bc0',
        text: 'Direct to your door when it suits you.',
        image: [
          {
            alt: '',
            _uid: '7700a577-d1e8-437c-ad49-134609076a6b',
            image: {
              id: 168_665_802_061_736,
              alt: 'Picture of two women standing next to a car with the keys in hand.',
              name: '',
              focus: '',
              title: '',
              source: '',
              filename:
                'https://a.storyblok.com/f/143588/2121x1414/43a343c6d9/people-stood-next-to-car.jpg',
              copyright: '',
              fieldtype: 'asset',
              meta_data: {
                alt: 'Picture of two women standing next to a car with the keys in hand.',
                title: '',
                source: '',
                copyright: '',
              },
              is_external_url: false,
            },
            component: 'Image',
          },
        ],
        heading: 'Prefer delivery?',
        iconName: 'home-delivery',
        component: 'SectionWithImageV2',
        iconColor: 'goGreen',
        buttonLabel: 'More about delivery',
        headingColor: '#8DFFBE',
        backgroundColor: '#5234B6',
      },
      {
        _uid: '1ad908b4-7989-4ee2-a9b9-362b9aec9b83',
        title: "After it's yours",
        content: [
          {
            _uid: 'ab70a708-e906-4a4d-992a-72ef7f161535',
            rows: [
              {
                _uid: '1e826133-a4d0-415a-8fdd-4784654e59b8',
                columns: [
                  {
                    _uid: '35e78e8f-695e-4c63-8666-99b682e449f3',
                    body: {
                      type: 'doc',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'To give you that extra peace of mind.',
                              type: 'text',
                            },
                          ],
                        },
                      ],
                    },
                    icon: 'our-commitment',
                    title: 'Free 90-day warranty',
                    component: 'FeatureCardV2',
                  },
                  {
                    _uid: '61d6c763-3e43-457f-9888-e4f4a1bbd09b',
                    body: {
                      type: 'doc',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Protect yourself against the cost of mechanical, electrical and cosmetic repairs with ',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#2F2F2F',
                                  },
                                },
                              ],
                            },
                            {
                              text: 'cinchCover',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/car-care/cinch-cover',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    icon: 'shield-heart',
                    title: 'Cover your car deserves',
                    component: 'FeatureCardV2',
                  },
                  {
                    _uid: '47c93a15-93b4-45d0-9bc7-f0aa6f4e0158',
                    body: {
                      type: 'doc',
                      content: [
                        {
                          type: 'paragraph',
                          attrs: {
                            textAlign: null,
                          },
                          content: [
                            {
                              text: 'Our ',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#2F2F2F',
                                  },
                                },
                              ],
                            },
                            {
                              text: '14-day money back guarantee',
                              type: 'text',
                              marks: [
                                {
                                  type: 'link',
                                  attrs: {
                                    href: 'https://www.cinch.co.uk/returns',
                                    uuid: null,
                                    anchor: null,
                                    target: null,
                                    linktype: 'url',
                                  },
                                },
                                {
                                  type: 'underline',
                                },
                              ],
                            },
                            {
                              text: ' is there if you change your mind.',
                              type: 'text',
                              marks: [
                                {
                                  type: 'textStyle',
                                  attrs: {
                                    color: '#2F2F2F',
                                  },
                                },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                    icon: 'cash',
                    title: 'Money back guarantee',
                    component: 'FeatureCardV2',
                  },
                ],
                component: 'GenericGridRow',
              },
            ],
            component: 'GenericGrid',
          },
        ],
        component: 'FeatureCardRowWrapper',
      },
      {
        _uid: '88f8a9b2-dc03-45be-8ec3-aa45fd55b316',
        title: 'Ready to hit the open road?',
        iconName: 'search',
        subtitle: "Let's find your next car",
        component: 'PreFooterCtaV2',
        buttonLabel: 'Search all cars',
        iconGradient: 'galaxy',
      },
    ],
    hero: [
      {
        _uid: '4faeb93b-d648-499c-ba8e-a87ed5738153',
        body: 'Prefer to collect your new motor? Choose a time and place that suits you – locations across the country, open six days a week.',
        image: {
          id: 168_665_801_742_242,
          alt: 'Picture of a car with a neon icon of a key in bright violet.',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/900x600/4f727730e1/collection-hero.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Picture of a car with a neon icon of a key in bright violet.',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        title: 'Collecting your car',
        component: 'GenericHero',
      },
    ],
    component: 'LandingPage',
  },
  slug: 'car-collections',
  full_slug: 'car-collections',
  sort_by_date: null,
  position: -300,
  tag_list: [],
  is_startpage: false,
  parent_id: 0,
  meta_data: null,
  group_id: '4037c170-e292-4260-b97b-b1917d788f4a',
  first_published_at: '2026-05-05T12:51:19.442Z',
  lang: 'default',
  alternates: [],
}
